import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { RiArrowRightLine } from "@remixicon/react"

import { ColorBand, ColorBandInner } from "@/components/landing/ColorBand"
import { MarketingPageShell } from "@/components/landing/MarketingPageShell"
import { fadeIn, fadeUp, inView } from "@/components/landing/marketing-motion"
import { Button } from "@/components/ui/button"

const founderImg =
  "https://res.cloudinary.com/da4c8kuqv/image/upload/v1774167335/about-1_qjceyh.jpg"
const teamRow1 =
  "https://res.cloudinary.com/da4c8kuqv/image/upload/v1774167335/about-3_zwriek.jpg"
const teamRow2 =
  "https://res.cloudinary.com/da4c8kuqv/image/upload/v1774167335/about-2_jxhqd8.jpg"

export function TeamPage() {
  return (
    <MarketingPageShell
      eyebrow="Team"
      title="People behind Sqaleshop"
      description="Sqaleup Inc. is a product-first company building digital products with speed, precision, and vision."
      heroVariant="muted"
      bare
    >
      <ColorBand className="bg-white text-black">
        <ColorBandInner>
          <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
            <motion.div {...fadeIn} className="flex justify-center lg:justify-start">
              <div className="overflow-hidden rounded-[3rem] sm:rounded-[4rem]">
                <img
                  src={founderImg}
                  alt="Imam Abubakar, Founder and Tech Lead of Sqaleup Inc."
                  className="aspect-3/4 w-full max-w-sm object-cover sm:max-w-md"
                  width={400}
                  height={520}
                />
              </div>
            </motion.div>
            <motion.div {...fadeUp}>
              <p className="font-heading text-sm font-semibold uppercase tracking-[0.18em] text-black">
                Founder
              </p>
              <h2 className="font-display mt-3 text-3xl leading-[0.92] sm:text-4xl lg:text-[3rem]">
                Imam Abubakar
              </h2>
              <p className="mt-5 max-w-xl text-base font-semibold leading-relaxed text-black xl:text-lg">
                Tech entrepreneur and senior software developer. He built
                Sqaleshop to help small businesses grow their online presence,
                increase sales, and scale, mainly because he was once in their
                shoes.
              </p>
            </motion.div>
          </div>
        </ColorBandInner>
      </ColorBand>

      <ColorBand className="bg-[#f6f4ef] text-black">
        <ColorBandInner>
          <motion.h2
            {...fadeUp}
            className="font-display max-w-2xl text-3xl leading-[0.92] sm:text-4xl lg:text-[3rem]"
          >
            The team in action
          </motion.h2>
          <div className="mt-10 grid gap-5">
            {[teamRow1, teamRow2].map((src, i) => (
              <motion.div
                key={src}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={inView}
                transition={{ delay: i * 0.06, duration: 0.45 }}
                className="overflow-hidden rounded-[2rem] sm:rounded-[2.5rem]"
              >
                <img
                  src={src}
                  alt=""
                  role="presentation"
                  className="aspect-video w-full object-cover"
                  loading="lazy"
                />
              </motion.div>
            ))}
          </div>
        </ColorBandInner>
      </ColorBand>

      <ColorBand className="bg-[#be9afc] text-primary">
        <ColorBandInner className="text-center">
          <motion.h2
            {...fadeUp}
            className="font-display text-3xl leading-[0.92] sm:text-4xl"
          >
            Want to join?
          </motion.h2>
          <p className="mx-auto mt-4 max-w-md text-base font-semibold text-primary/75">
            We&rsquo;re hiring merchant-obsessed builders and communicators.
          </p>
          <Button
            size="xl"
            className="mt-8 rounded-full bg-primary px-8 font-semibold text-white shadow-none hover:bg-primary/90 hover:text-white"
            asChild
          >
            <Link to="/careers" className="gap-2">
              See careers
              <RiArrowRightLine className="size-4" />
            </Link>
          </Button>
        </ColorBandInner>
      </ColorBand>
    </MarketingPageShell>
  )
}
